export const formatTextToId = (text: string): string => {
	return text.toLowerCase().split(' ').join('_');
};
